<mat-card class="chart-card" (dblclick)="openFullscreen()">
  <mat-card-header>
    <mat-card-title>{{ title }}</mat-card-title>
    <div class="header-actions">
      <mat-icon
        *ngIf="tooltip"
        class="info-icon"
        [matTooltip]="tooltip">info_outline</mat-icon>
      <button
        mat-icon-button
        class="fullscreen-btn"
        (click)="openFullscreen()"
        [attr.aria-label]="'Abrir gráfico ' + title + ' em visualização ampliada'"
        matTooltip="Visualização ampliada">
        <mat-icon>open_in_full</mat-icon>
      </button>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div
      class="chart-scroll-container"
      [class.scroll-horizontal]="scrollDirection === 'horizontal'">
      <div
        [style.height.px]="scrollDirection === 'vertical' ? dynamicHeight : 260"
        [style.width.px]="scrollDirection === 'horizontal' ? dynamicWidth : null"
        class="chart-inner">
        <canvas
          baseChart
          [data]="chartData"
          [options]="chartOptions"
          [type]="chartType">
        </canvas>
      </div>
    </div>
  </mat-card-content>
</mat-card>
